var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404TrafficCone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 106,
    viewBox: "0 0 102 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8533 99.7701H7.47266L20.9999 66.9459L26.4222 53.6951L27.9336 50.0795L30.3707 44.1545L30.862 42.962L36.3031 29.7111L37.3044 27.307L46.9398 3.87194C47.3226 2.93161 47.9764 2.12691 48.8176 1.56043C49.6588 0.993944 50.6494 0.691406 51.663 0.691406C52.6766 0.691406 53.6672 0.993944 54.5084 1.56043C55.3496 2.12691 56.0034 2.93161 56.3862 3.87194L66.0215 27.307L67.0229 29.7111L72.4451 42.962L72.9552 44.1545L75.3924 50.0795L76.8849 53.6951L82.326 66.9459L95.8533 99.7701Z",
    fill: "#FFC700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2727 85.707L7.47266 99.7719H95.8533L90.0532 85.707H13.2727Z",
    fill: "#FFC700"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.615 91.3672H0.40625V105.697H101.615V91.3672Z",
    fill: "#79C9E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.617 91.3672H79.7578V105.697H101.617V91.3672Z",
    fill: "#49B4D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3771 91.3662H79.87L69.819 66.9658L64.3968 53.715L62.8854 50.0804L60.5049 44.1554L60.0137 42.9439L54.5725 29.6931L53.5145 27.3269L45.3906 7.5642L46.902 3.77825C47.2849 2.83792 47.9386 2.03316 48.7798 1.46668C49.6211 0.900194 50.6117 0.597656 51.6252 0.597656C52.6388 0.597656 53.6294 0.900194 54.4706 1.46668C55.3119 2.03316 55.9656 2.83792 56.3484 3.77825L65.9838 27.2133L66.9851 29.6174L72.4073 42.8682L72.9175 44.0797L75.3546 49.9858L76.8472 53.6203L82.2883 66.8712L92.3771 91.3662Z",
    fill: "#FFC700"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4464 42.9423H30.8633L36.3044 29.6914H67.0052L72.4464 42.9423Z",
    fill: "#0582C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3254 66.9266V66.9455H20.9805V66.9266L26.4216 53.6758H76.8843L82.3254 66.9266Z",
    fill: "#0582C1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4448 42.9423H59.9567L54.5156 29.6914H67.0037L72.4448 42.9423Z",
    fill: "#00668E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3271 66.9266V66.9455H69.82V66.9266L64.3789 53.6758H76.8859L82.3271 66.9266Z",
    fill: "#00668E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404TrafficCone);
export default __webpack_public_path__ + "static/media/404_traffic_cone.a02b82d8f7a8a32b238653321df5407e.svg";
export { ForwardRef as ReactComponent };